module.exports = __webpack_public_path__ + "static/img/gpt45.b61c2ce5.png";